import "bootstrap";
import General from "./components/_general";
import Menu from "./components/_menu";
import Map from "./components/_map";
import Slider from "./components/_slider";


const App = {
  /**
   * App.init
   */
  init() {
    // General scripts
    function initGeneral() {
      return new General();
    }
    initGeneral();

    // Menu scripts
    function initMenu() {
      return new Menu();
    }
    initMenu();

    // Map scripts
    function initMap() {
      return new Map();
    }
    initMap();

    // Slider scripts
    function initSlider() {
      return new Slider();
    }
    initSlider();
  },
};

document.addEventListener("DOMContentLoaded", () => {
  App.init();
});
